import { render, staticRenderFns } from "./DailyBriefAcceptModal.vue?vue&type=template&id=696639e4&scoped=true"
import script from "./DailyBriefAcceptModal.vue?vue&type=script&lang=js"
export * from "./DailyBriefAcceptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696639e4",
  null
  
)

export default component.exports